import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Card, CardContent } from '@availity/element';

const CustomCard = ({
  children = [],
  paddingSize = '40px',
  cardWidth = '100',
  className,
  backgroundColor = '#FFFFFF',
}) =>
  (
    <Card
      style={{
        width: `${cardWidth}%`,
        backgroundColor,
      }}
      className={className}
      id='main-card'
    >
      <CardContent id='main-card-content' style={{ padding: `${paddingSize}` }}>{children}</CardContent>
    </Card>
  )

export default observer(CustomCard);

CustomCard.propTypes = {
  children: PropTypes.node,
  paddingSize: PropTypes.string,
  cardWidth: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
};